import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Image, { IImage } from '../Image';

export interface IVHSImageBarProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Images
	 */
	images?: IImage[];
}

/**
 * Image Bar
 * @block
 * @icon images-alt
 */
const VHSImageBar: React.FC<IVHSImageBarProps> = ({
	heading,
	images = [],
	className,
	classNames = [],
}) => {
	return (
		<div className={className || cn('vhs-image-bar', ...classNames)}>
			<div className="vhs-image-bar__container">
				{heading && <h2 className="vhs-image-bar__heading">{heading}</h2>}
				{images.length > 0 &&
					<div className="vhs-image-bar__wrapper">
						{images.map(( image, index ) => (
							<div key={index} className="vhs-image-bar__image-wrapper">
								<Image {...image} className="vhs-image-bar__image" />
							</div>
						))}
					</div>
				}
			</div>
		</div>
	);
};

export default VHSImageBar;

